import Flickity from '../../../../node_modules/flickity/js/index';
import '../../../css/flickity.pcss';

export default Flickity;
